module.exports = __webpack_public_path__ + "static/img/top-img5.8f30ab7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/top-img5.png
// module id = bRVF
// module chunks = 0